<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <media-history-table />
      </div>
    </div>
    <!-- <div class="row">
      <div class="col-12">
        <projects-table />
      </div>
    </div> -->
  </div>
</template>

<script>
import MediaHistoryTable from "./components/MediaHistoryTable";
// import ProjectsTable from "./components/ProjectsTable";

export default {
  name: "Users",
  components: {
    MediaHistoryTable,
    // ProjectsTable,
  },
};
</script>
